module.exports = __webpack_public_path__ + "static/after2-39f9258aec54eddbe641b282391ec8a2.png";